<template>
  <div class="chat-pane">
    <div v-if="conversation === null" class="convo-pane text-bg-user-primary">
      <div id="channels" class="conversations">
        <div class="collapser" role="button">
          Channels
        </div>
        <div visible class="convo-block">
          <div v-for="(channel, index) in conversations.filter(convo => convo.id < 0)" :key="index"  role="button">
            <span>
              <div v-if="channel.unread > 0" class="convo unread-convo" @click="openConvo(channel.id)">
                # {{ channel.name }}
                <span class="right unread">
                  {{ channel.unread }}
                </span>
              </div>
              <div v-else class="convo" @click="openConvo(channel.id)">
                # {{ channel.name }}
              </div>
            </span>
            <span v-if="role === 'unassigned'">
              <div v-if="channel.unread > 0" class="convo unread-convo" @click="openConvo(channel.id)">
                # {{ channel.name }}
                <span class="right unread">
                  {{ channel.unread }}
                </span>
              </div>
              <div v-else class="convo" @click="openConvo(channel.id)">
                # {{ channel.name }}
              </div>
            </span>
          </div>
        </div>
      </div>
      <div id="direct" class="conversations">
        <div v-b-toggle.collapse-2 class="collapser" role="button">
          <span class="when-opened">
            <i class="fa fa-chevron-down toggler" />
          </span>
          <span class="when-closed">
            <i class="fa fa-chevron-right toggler" />
          </span>
          Direct Messages
        </div>
        <b-collapse id="collapse-2" visible class="convo-block mt-2" role="button">
          <span v-for="(user, index) in conversations.filter(user => user.id >= 0 || (user.id < 0 && !user.members))" :key="index" role="button">
            <div v-if="user.unread > 0" class="convo unread-convo" @click="openConvo(user.id, user.name)">
              <i class="fa fa-circle online-circle is-online" v-if="user.online === true" />
              <i class="fa fa-circle online-circle not-online" v-else />
              {{ user.name }}
              <span v-if="user.role">
                - {{ user.role }}
              </span>
              <span v-if="user.unread > 0" class="right unread">
                {{ user.unread }}
              </span>
            </div>
            <div v-else class="convo" @click="openConvo(user.id, user.name)">
              <i class="fa fa-circle online-circle is-online" v-if="user.online === true" />
              <i class="fa fa-circle online-circle not-online" v-else />
              {{ user.name }}
              <span v-if="user.role">
                - {{ user.role }}
              </span>
            </div>
          </span>
        </b-collapse>
      </div>
    </div>
    <div v-else class="convo-pane">
      <div class="header">
        <div @click="backToList">
          <i class="fa fa-arrow-alt-circle-left" />
        </div>
        <div class="content d-inline-block">
          <span v-if="conversation.id < 0 && conversation.members" class="text"># </span>{{ conversation.name }}
          <span v-if="conversation.role !== undefined">- {{ conversation.role }}</span>
          <br>
          <span v-if="conversation.id < 0 && conversation.members" class="members">
            {{ members }} members in this channel
          </span>
        </div>
      </div>
      <div class="p-0 messages">
        <div ref="chat">
          <div v-for="(message, index) in conversation.messages" :key="index" class="p-2">
            <strong>{{ message.senderName }}</strong>
            {{ message.message }}
            <span v-if="message.videoUrl">
              <br>
              <video width="320" height="240" controls>
                <source :src="message.videoUrl" type="video/mp4">
                <track kind="captions" :src="message.captionsPath" srclang="en-us" label="English"/>
                Your browser does not support the video tag.
              </video>
            </span>
            <span class="timestamp">{{ formatDate(message.timestamp) }}</span>
          </div>
        </div>
        <div class="convo-input">
          <div class="typing-panel" v-show="chatbotTyping">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p class="typing-text">{{ chatbotSender }} is typing...</p>
          </div>
          <b-form-input
            v-model="newMessage"
            type="text"
            name="message"
            placeholder="Enter your message..."
            class="form-control footer"
            @keyup.enter="sendMessage()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  layout: 'basepcs',

  data: () => ({
    newMessage: '',
    video: '',
    groupID: '',
    conversation: null,
    chatbotTyping: false,
    chatbotSender: ''
  }),

  computed: {
    ...mapState({
      conversations: state => state.chat.conversations,
      user: state => state.auth.user,
      members: function() {
        if (this.conversation.members.length === 0) {
          return 'all'
        } else {
          return this.conversation.members.length
        }
      },
      role: state => state.group.role.name,
    }),
    ...mapGetters({
      classId: 'auth/classId',
      bubbleOpen: 'chat/bubbleOpenState',
    }),
  },

  watch: {
    bubbleOpen: function() {
      if (!this.bubbleOpen) {
        this.conversation = null
      }
    },
  },

  created() {
    axios.post('/api/getGroup', {
      params: {
        pcs: localStorage.getItem('pcs'),
        classId: this.classId,
      },
    })
    .then(response => {
      this.groupID = response.data
      this.getChatData()

      if (this.groupID) {
        Echo.join('group.chat.' + this.groupID)
        .here(user => {
          user.forEach(user => {
            this.$store.state.chat.conversations.forEach(usr => {
              if (user.id === usr.id) {
                usr.online = true
              }
            })
          })
        })
        .joining(user => {
          this.$store.state.chat.conversations.forEach(usr => {
            if (user.id === usr.id) {
              usr.online = true
            }
          })
        })
        .leaving(user => {
          this.$store.state.chat.conversations.forEach(usr => {
            if (user.id === usr.id) {
              usr.online = false
            }
          })
        })
        .listen('MessageSent', (event) => {
          if (event.recipientid === this.user.id || event.recipientid <= 0) {
            event.currentConversation = this.conversation
            this.receiveMessage(event)
            if ((event.recipientid < 0 && this.conversation.id == event.recipientid) || (event.recipientid >= 0 && this.conversation.id === event.senderid)) { // If the message is sent to the current opened conversation
              this.scrollToBottom()
            }
          }
        })
      }
    })
  },

  methods: {
    ...mapActions({
      updateState: 'chat/saveState',
      triggerDialogflow: 'chat/triggerDialogflow',
      sendChatMessage: 'chat/sendMessage',
      addMessageToState: 'chat/addMessageToState',
      receiveMessage: 'chat/receiveMessage',
    }),

    formatDate(value) {
      if (value) {
        return moment(String(value)).format('llll')
      }
    },

    getChatData: function() {
      axios.post('/api/pcs/chat', {
        params: {
          pcs: localStorage.getItem('pcs'),
          group: this.groupID,
          classId: this.classId,
        },
      })
      .then(response => {
        this.users = response.data.users
        this.channels = response.data.channels
      })
    },

    openConvo: function(id, name) {
      if (id === 0) {
        this.conversations.forEach(convo => {
          if ((convo.id === id) && (convo.name === name)) {
            convo.unread = 0
            this.conversation = convo
          }
        })
      } else {
        this.conversations.forEach(convo => {
          if (convo.id === id) {
            convo.unread = 0
            this.conversation = convo
          }
        })
      }
      this.updateState()
      this.scrollToBottom()
    },

    backToList: function() {
      this.conversation = null
    },

    sendMessage: function() {
      if (this.newMessage == '') {
        return
      }
      let recipient = this.conversation.name
      let recipientid = this.conversation.id

      let event = {
        message: this.newMessage,
        sender: this.user.name,
        senderid: this.user.id,
        recipient: recipient,
        recipientid: recipientid,
        timestamp: new Date(),
        video: this.video,
        currentConversation: this.conversation,
      }

      // Handle stuff on user's end (add message to user's state)

      this.addMessageToState(event)


      // Handle stuff with other people/chatbots

      if (this.conversation.chatbot) {
        this.sendMessageToChatbot()
      }
      else if (recipientid >= 0 && !this.conversation.isCharacter) {
        // sending direct message
        let active = this.checkIfOnline(recipient)
        if (active) {
          // if they are on broadcast normally
          this.broadcast(recipient, recipientid)
        } else {
          // if they aren't on
          this.sendToOffline(recipient, recipientid)
        }
      } else if (recipientid < 0) {
        // sending to channel
        this.broadcast(recipient, recipientid)
        // add message to states of users not online
        if (this.conversation.members === []) {
          // channel including all team members
          this.users.forEach((user) => {
            if (!this.checkIfOnline(user.name)) { // If recipient is not online
              this.sendToOffline(user.name, user.id, recipientid)
            }
          })
        }
      }
      this.updateState()

      this.newMessage = ''

      this.scrollToBottom()
    },

    sendMessageToChatbot: async function () {
      if (this.newMessage == "") {
          return;
      }
      
      let data = {
          message: this.newMessage,
          recipient: this.conversation.name,
          recipientid: this.conversation.id,
          returnMessages: true,
      }

      let messages = await this.triggerDialogflow(data)
      if (Array.isArray(messages)) {
        for (const message of messages) {
          await this.addMessageFromChatbot(message)
          this.scrollToBottom()
        }
      } else {
        await this.addMessageFromChatbot(messages)
        this.scrollToBottom()
      }
    },

    addMessageFromChatbot: function (message) {
      return new Promise((resolve) => {
        this.chatbotSender = message.sender
        this.chatbotTyping = true
        if (this.conversation !== null) {
          this.scrollToBottom()
        }
        let delay = 0
        
        if (message.message.length <= 100) {
          delay = Math.random() + 1
        }
        else if (message.message.length <= 200) {
          delay = Math.random() + 2
        }
        else if (message.message.length <= 300) {
          delay = Math.random() + 3
        }
        else {
          delay = Math.random() + 5
        }
        let appScope = this

        setTimeout(function() {
          appScope.sendChatMessage(message)
          appScope.chatbotTyping = false
          appScope.chatbotSender = ''
          resolve()
        }, delay * 1000);
      })
    },

    scrollToBottom () {
      this.$nextTick(() => {
        this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight
      })
    },

    checkIfOnline: function(recipient) {
      // check if the other user is on
      return this.conversations.find((user) => { 
        return (user.name === recipient) 
      }).online
    },

    sendToOffline: function(recipient, id) {
      axios.post('/api/messageOffline', {
        params: {
          message: this.newMessage,
          pcs: localStorage.getItem('pcs'),
          classId: this.classId,
          sender: this.user.name,
          senderid: this.user.id,
          recipient: recipient,
          recipientid: id,
          timestamp: new Date(),
          video: this.video,
        },
      })
    },

    broadcast: function(recipient, id) {
      axios.post('/api/message', {
        params: {
          message: this.newMessage,
          pcs: localStorage.getItem('pcs'),
          classId: this.classId,
          recipient: recipient,
          recipientid: id,
          name: this.user.name,
          id: this.user.id,
          timestamp: new Date(),
          all: false,
          video: this.video,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.is-online {
  color: #07d54b;
}

.not-online {
  color: rgb(151, 151, 151);
}

.right {
  float: right;
}

.timestamp{
  display: block;
  font-size: 10px;
  opacity: 50%;
}

.chat-pane{
  display: flex;
  flex-flow: row;
  height: 100%;
  margin: 0;

  /* Channel and Direct Conversation Select */
  .conversations {
    margin: 15px;
  }

  .convo-block {
    margin-left: 20px;
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .convo {
    display: block;
    color: black !important;
    padding: 6px;
    border-radius: .5rem;
  }

  .unread {
    font-size: 10px;
    color: white;
    padding: 0 10px;
    border-radius: .5rem;
    background-color: #7abaff;
  }

  .unread-convo {
    color: #007bff;
    font-weight: bold;
    background-color: #9de0f6;
  }

  /* Conversation pane */
  .convo-pane {
    flex: 1 1 auto;
    display: flex;
    flex-flow: column;
    overflow-y: auto;
    width: 40%;

    .header {
      flex: 0 1 auto;
      padding: 10px;

      a {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
      }

      .content {
        margin-left: 20px;

        .members {
          font-size: 10px;
        }
      }
    }

    .messages {
      flex: 1 1 auto;
      height: inherit;
      display: flex;
      position: relative;
      flex-flow: column;
      margin-bottom: 10px;
      overflow-y: auto;

      ul {
        max-height: 450px;
        flex: 1 1 auto;
        height: auto;
        overflow-y: auto;
      }
    }
  }
}

.footer {
  flex: 0 1 40px;
}
.typing-panel {
  display: flex;
  align-items: baseline;
}

.typing-text {
  margin-left: 5px;
  font-size: 12px;
}

.typing-indicator {
  will-change: transform;
  width: auto;
  border-radius: 10%;
  display: table;
  margin-bottom: 12px;
  position: relative;
  animation: 2s bulge infinite ease-out;
  span {
    height: 7px;
    width: 7px;
    float: left;
    margin: 0 1px;
    background-color: #9E9EA1;
    display: block;
    border-radius: 50%;
    opacity: 0.4;
    @for $i from 1 through 3 {
      &:nth-of-type(#{$i}) {
        animation: 1s blink infinite ($i * .3333s);
      }
    }
  }
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}

@keyframes bulge {
  50% {
    transform: scale(1.05);
  }
}

</style>
